import { db } from "../firebaseConfig";
import {
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
  Timestamp,
  getCountFromServer,
} from "firebase/firestore";

/**
 * Récupère les métriques du dashboard admin
 * - Compteurs (produits par statut, marques, catégories, stock bas)
 * - Derniers produits ajoutés
 * - Nombre de produits ajoutés par jour (7 derniers jours)
 */
export async function getDashboardMetrics() {
  const productsRef = collection(db, "products");
  const brandsRef = collection(db, "brands");
  const categoriesRef = collection(db, "categories");

  // Compteurs rapides (Agrégation COUNT côté serveur)
  const [
    totalProductsSnap,
    activeSnap,
    draftSnap,
    archivedSnap,
    lowStockSnap,
    totalBrandsSnap,
    totalCategoriesSnap,
  ] = await Promise.all([
    getCountFromServer(query(productsRef)),
    getCountFromServer(query(productsRef, where("status", "==", "active"))),
    getCountFromServer(query(productsRef, where("status", "==", "draft"))),
    getCountFromServer(query(productsRef, where("status", "==", "archived"))),
    getCountFromServer(query(productsRef, where("stock", "<=", 3))),
    getCountFromServer(query(brandsRef)),
    getCountFromServer(query(categoriesRef)),
  ]);

  const count = (snap) => snap.data().count || 0;

  // Derniers produits
  const recentSnap = await getDocs(
    query(productsRef, orderBy("createdAt", "desc"), limit(5))
  );
  const recentProducts = recentSnap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
  }));

  // Répartition par jour sur 7 jours (incluant aujourd'hui)
  const now = new Date();
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - 6); // 6 jours avant + aujourd'hui = 7 jours
  const startTs = Timestamp.fromDate(start);

  const weekSnap = await getDocs(
    query(
      productsRef,
      where("createdAt", ">=", startTs),
      orderBy("createdAt", "asc")
    )
  );

  const byDay = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    return { date: d, key: d.toISOString().slice(0, 10), count: 0 };
    // key format: YYYY-MM-DD
  });

  weekSnap.docs.forEach((doc) => {
    const ts = doc.data().createdAt;
    const dt = ts?.toDate ? ts.toDate() : null;
    if (!dt) return;
    const key = dt.toISOString().slice(0, 10);
    const slot = byDay.find((x) => x.key === key);
    if (slot) slot.count += 1;
  });

  return {
    counts: {
      totalProducts: count(totalProductsSnap),
      activeProducts: count(activeSnap),
      draftProducts: count(draftSnap),
      archivedProducts: count(archivedSnap),
      lowStockProducts: count(lowStockSnap),
      totalBrands: count(totalBrandsSnap),
      totalCategories: count(totalCategoriesSnap),
    },
    recentProducts,
    byDay,
  };
}

/*
🔎 Indexes conseillés si Firestore les réclame :
- products: createdAt DESC
- products: status ASC, createdAt DESC
*/
